export default function thousandSeparator(number) {
  // Treat 0 as a real value (was previously caught by the falsy check
  // and rendered as `null` — surfaced as e.g. "null EUR" in stats rows
  // where paid_in === 0). Only null/undefined/NaN still return null so
  // callers can choose their own placeholder.
  if (number == null || Number.isNaN(Number(number))) return null;
  const userLocale = navigator.language || 'en-US';
  return new Intl.NumberFormat(userLocale).format(Number(number));
}
